import classNames from "classnames"
import { forwardRef } from "react"
import { Heading } from "../../Heading"
import { Text } from "../../Text"
import { LayoutHeaderProps } from "./types"
import { LayoutVariation } from "../types"
import { useLayoutContext } from "../LayoutContext"

// TODO do something with this
const HEADER_TEXT_ALIGN_CENTER_LAYOUTS: LayoutVariation[] = ["form", "tools", "wizard"]

export const LayoutHeader = forwardRef<HTMLElement, LayoutHeaderProps>(
  ({ align, actionButtons, beforeHeader, subtitle, title = null, ...rest }, ref) => {
    const { variation } = useLayoutContext()
    const isHeaderTextAlignCenter =
      typeof align === "undefined"
        ? Boolean(variation && HEADER_TEXT_ALIGN_CENTER_LAYOUTS.includes(variation))
        : align === "center"

    const showBeforeHeaderContainer = beforeHeader || (isHeaderTextAlignCenter && actionButtons)
    const _title = typeof title === "string" ? <Heading size="3xl">{title}</Heading> : title

    // Accounts for subtitles with inline elements such as <a/> or <span/>
    const _subtitle =
      typeof subtitle === "string" ? (
        <Text size="medium" className="text-gray-400">
          {subtitle}
        </Text>
      ) : (
        <div className="text-gray-400">{subtitle}</div>
      )

    return (
      <header ref={ref} {...rest}>
        {showBeforeHeaderContainer && (
          <div className="mb-4 flex min-h-11 items-center">
            {beforeHeader}
            {isHeaderTextAlignCenter && (
              <div className="ms-auto flex gap-2 empty:hidden">{actionButtons}</div>
            )}
          </div>
        )}
        <div className="mb-6 space-y-4 empty:hidden md:mb-8 md:flex md:space-y-0">
          {(_title || _subtitle) && (
            <div className={classNames("w-full", isHeaderTextAlignCenter && "text-center")}>
              {_title}
              {_subtitle}
            </div>
          )}
          {!isHeaderTextAlignCenter && actionButtons && (
            <div className="shrink-0 items-start space-y-2 children:w-full md:flex md:space-x-2 md:space-y-0 md:children:w-auto">
              {actionButtons}
            </div>
          )}
        </div>
      </header>
    )
  },
)

LayoutHeader.displayName = "Layout.Header"
